var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "22px",
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Document icon/docx") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5441176,20.3076923 L1.45588235,20.3076923 C0.651821029,20.3076923 0,19.6582418 0,18.8571429 L0,1.45054945 C0,0.649433407 0.651821029,0 1.45588235,0 L11.25,0 L18,6.72527473 L18,18.8571429 C18,19.6582418 17.3481618,20.3076923 16.5441176,20.3076923 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u270F\\uFE0F-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-105.000000, -1669.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-icon/docx",
    transform: "translate(105.333333, 1669.833333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5441176,20.3076923 L1.45588235,20.3076923 C0.651821029,20.3076923 0,19.6582418 0,18.8571429 L0,1.45054945 C0,0.649433407 0.651821029,0 1.45588235,0 L11.25,0 L18,6.72527473 L18,18.8571429 C18,19.6582418 17.3481618,20.3076923 16.5441176,20.3076923 Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,6.72527473 L12.7058824,6.72527473 C11.9018382,6.72527473 11.25,6.07584396 11.25,5.27472527 L11.25,0 L18,6.72527473 Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.3701081,13.5548752 L7.39363462,13.5548752 C7.40259954,13.4415797 7.4212722,13.3050553 7.44966539,13.145315 C7.47805859,12.9855618 7.50364704,12.8505523 7.52643075,12.7402866 L8.60670406,8.02831742 L10.0035544,8.02831742 L11.1241699,12.6694736 L11.1426632,12.6694736 L12.0363509,8 L13.3076923,8 L11.7377036,14.7524159 L10.5083949,14.7524159 L9.44381021,10.3066848 C9.41299648,10.1780976 9.3777003,10.0098504 9.33903586,9.80308278 C9.30037143,9.59631513 9.2762814,9.44506879 9.26675296,9.34990051 L9.24825961,9.34990051 C9.23593924,9.45979074 9.2118364,9.6229493 9.17597671,9.83933736 C9.14011701,10.0557384 9.11135242,10.2158541 9.08968291,10.3197106 L8.08896691,14.7773279 L6.57837727,14.7773279 L5,8.02830447 L6.29430445,8.02830447 L7.26756218,12.749894 C7.28942379,12.8467715 7.31015837,12.9759284 7.33032945,13.1356816 C7.35050053,13.2959916 7.36394792,13.4353516 7.3701081,13.5548752 Z",
    id: "Path",
    fill: "#0058C2",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.44a1aed7ed94f069c04d5fc1b7748115.svg";
export { ForwardRef as ReactComponent };